import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../../../web-shared/login.css";
import "./styles.css";
import "./styles/ticket-detail.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
